import RingHeader from '@jetbrains/ring-ui/components/header/header'
import * as React from 'react'

import HeaderTray from './Header.tray'
import {getAdminSpaceAvailable} from './Header.utils'
import HeaderLinks from './Links/Links'

import styles from './Header.css'

export type HeaderProps = {
  adminSpaceAvailable?: boolean
}

function Header({adminSpaceAvailable = getAdminSpaceAvailable()}: HeaderProps) {
  return (
    <RingHeader vertical data-test-main-nav className={styles.header}>
      <HeaderLinks adminSpaceAvailable={adminSpaceAvailable} />
      <HeaderTray />
    </RingHeader>
  )
}

export default React.memo(Header)
